import MarketStats from 'app/shared/models/MarketStats';
import api from 'app/shared/utils/api';
import { getFAQParamsQuery, getMarketDataQuery, getTopMarketsQuery } from 'app/shared/utils/queries';
import constants from 'app/shared/flux/constants';
import TopMarkets from 'app/shared/models/TopMarkets';
import { isEmpty } from 'app/shared/utils/marketStatsUtils';

const NON_CRITICAL_ERRORS = ['INVALID_INPUT'];

export const getMarketStats = (params: { resourceId: string; bedrooms?: string; propertyTypes?: string }) => {
    const { resourceId, bedrooms, propertyTypes } = params;
    // @ts-ignore
    return async (dispatch) => {
        let res = {};
        const { data, errors } = await dispatch(
            api.area.graphQlMarketData(getMarketDataQuery({ resourceId, bedrooms, propertyTypes }))
        ); // when resourceId is invalid (e.g. not-a-real-id) this throws an error, so marketStats stays empty

        const marketStats = new MarketStats(data.marketPage, resourceId);
        const hasFilters = bedrooms || propertyTypes;
        if (!hasFilters) {
            dispatch({
                type: constants.SET_UNFILTERED_MARKET_STATS,
                payload: marketStats
            });
        }
        if (isEmpty(marketStats)) {
            await dispatch(getTopMarkets(params));
            res = { changeHttpStatus: 404 };
        }
        dispatch({
            type: constants.SET_MARKET_STATS,
            payload: marketStats
        });
        if (errors.length > 0) {
            errors.forEach((error: Error) => {
                // @ts-ignore
                if (!error.code in NON_CRITICAL_ERRORS) {
                    // @ts-ignore
                    throw new Error(error.code);
                }
            });
        }
        return res;
    };
};

export const getUnfilteredMarketStats = (resourceId: string) => {
    // @ts-ignore
    return async (dispatch) => {
        const { data, errors } = await dispatch(api.area.graphQlMarketData(getFAQParamsQuery(resourceId)));
        dispatch({
            type: constants.SET_UNFILTERED_MARKET_STATS,
            payload: new MarketStats(data.marketPage, resourceId)
        });
        if (errors.length > 0) {
            errors.forEach((error: Error) => {
                // @ts-ignore
                if (!error.code in NON_CRITICAL_ERRORS) {
                    // @ts-ignore
                    throw new Error(error.code);
                }
            });
        }
        return {};
    };
};

export const getTopMarkets = (params: { bedrooms?: string; propertyTypes?: string }) => {
    // @ts-ignore
    return async (dispatch) => {
        const { data, errors } = await dispatch(api.area.graphQlMarketData(getTopMarketsQuery(params)));
        if (errors.length > 0) {
            throw new Error(errors[0].code);
        }
        dispatch({
            type: constants.SET_TOP_MARKETS,
            payload: new TopMarkets(data)
        });
        return {};
    };
};
